<button id="TimerButton"
    class="{{state}} on_{{background}} {{timerState}}"
    [title]="getTooltip()"
    (click)="timerClicked.emit()">
    @if (state == 'badge') {
        <svg class="unity-icon-stopwatch">
            <use xlink:href="#unity-icon-stopwatch"></use>
        </svg>
        @if (includeTimeInfo) {
        <span class="timer">
            <span id="TaskTime">
                <sm-time-since [start]="dueOn" [displayTimeUntil]="timerState != 'late'"/>
            </span>
        </span>
        }
    } @else if (state == 'bar') {
        <span class="timer_badge--task_name single_line_ellipsis">
            <h2 id="TaskName" class="sle">{{ taskName }}</h2>
        </span>
        <button class="inner {{timerState}}" [ngClass]="{ 'badge': timerState != 'late', 'standalone standalone_on_red': timerState == 'late'}">
            <svg class="unity-icon-stopwatch">
                <use xlink:href="#unity-icon-stopwatch"></use>
            </svg>
            @if (includeTimeInfo) {
            <span class="timer">
                <span id="TaskTime">
                    <sm-time-since [start]="dueOn" [displayTimeUntil]="timerState != 'late'"/>
                </span>
            </span>
            }
        </button>     
    } @else {
        @if (timerState != 'late') {
        <svg class="unity-icon-stopwatch">
            <use xlink:href="#unity-icon-stopwatch"/>
        </svg>
        }
        @if (timerState == 'late') {
        <svg class="unity-icon-stopwatch-fill">
            <use xlink:href="#unity-icon-stopwatch-fill" />
        </svg>
        }
        @if (includeTimeInfo) {
        <sm-time-since id="TaskTime" [start]="dueOn" [displayTimeUntil]="timerState != 'late'"/>
        }
    }
</button>
